var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subscription-blocked"
  }, [_c('div', {
    staticClass: "subscription-blocked__card"
  }, [_c('div', {
    staticClass: "subscription-blocked__icon"
  }, [_c('v-icon', {
    attrs: {
      "size": "44",
      "color": "#ffb74d"
    }
  }, [_vm._v("mdi-pause-circle-outline")])], 1), _c('h1', {
    staticClass: "subscription-blocked__title"
  }, [_vm._v("Работа системы временно приостановлена")]), _c('p', {
    staticClass: "subscription-blocked__text"
  }, [_vm._v(" Доступ к CRM будет восстановлен автоматически после продления оплаты. Все входящие заявки и звонки продолжают сохраняться — ничего не потеряется. ")]), _c('p', {
    staticClass: "subscription-blocked__hint"
  }, [_vm._v("По вопросам продления обратитесь к администратору.")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "#ffb74d",
      "loading": _vm.checking
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('recheck');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-refresh")]), _vm._v(" Проверить снова ")], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }